// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qNYzPTwAqqksW55v1mTQ{flex-direction:column;gap:4px;display:flex}.VYaRf9AUQw97CIwTw3Nv{height:20px;color:var(--content-negative-primary);align-items:center;gap:4px;margin-top:4px;display:flex}.wCuRrRbjosUIDVut3Da_{flex-direction:column;gap:4px;padding:8px 0;display:flex}.wCuRrRbjosUIDVut3Da_:empty{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `qNYzPTwAqqksW55v1mTQ`,
	"error": `VYaRf9AUQw97CIwTw3Nv`,
	"alerts": `wCuRrRbjosUIDVut3Da_`
};
export default ___CSS_LOADER_EXPORT___;
